<template>
  <PanelDropdown
    v-model="isMenuOpen"
    side="bottom"
    align="end"
  >
    <template #trigger>
      <ActionButton
        :variant="isMenuOpen ? 'tertiary' : 'invert'"
        :color="isMenuOpen ? 'brand' : 'info'"
        class="LangCurrencyToggler-trigger"
        leftIcon="web"
        :rightIcon="isMenuOpen ? 'chevron-up' : 'chevron-down'"
      >
        {{ currentLanguageLabel }}
      </ActionButton>
    </template>

    <div class="LangCurrencyToggler-content">
      <LangCurrencyForm
        v-model:language="selectedLanguage"
        v-model:currency="selectedCurrency"
        :languageOptions="languageOptions"
        :currencyOptions="currencyOptions"
        :currencyDisabled="isCurrencyDisabled"
        :currencyVisible="isCurrencyVisible"
        :loading="isLoading"
        @confirm="handleConfirm"
      />
    </div>
  </PanelDropdown>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import LangCurrencyForm from './LangCurrencyForm.vue';

const {
  selectedLanguage,
  selectedCurrency,
  isLoading,
  languageOptions,
  currencyOptions,
  isCurrencyDisabled,
  isCurrencyVisible,
  currentLanguageLabel,
  resetSelections,
  confirmChanges,
} = useLangCurrency();

const isMenuOpen = ref(false);

// Reset selections when menu is closed without confirming
watch(isMenuOpen, (isOpen) => {
  if (!isOpen) {
    resetSelections();
  }
});

async function handleConfirm() {
  await confirmChanges();
  isMenuOpen.value = false;
}
</script>

<style lang="scss">
@use 'assets/scss/theme' as vars;

@layer cvo-base {
  .LangCurrencyToggler {
    &-content {
      display: flex;
      flex-direction: column;
      gap: vars.$dimensions-d-4;
      width: 268px;
    }
  }
}
</style>
